import React from "react";
import dynamic from "next/dynamic";

const Container = dynamic(
  () => import("@/components/Container").then((mod) => mod.Container),
  { ssr: true }
);

const pillars = [
  {
    icon: "🤖",
    title: "AI does the work",
    description:
      "Automated bank feeds, smart categorisation, instant reconciliation, anomaly detection — all running 24/7.",
  },
  {
    icon: "👁️",
    title: "Humans verify",
    description:
      "Every transaction, every report, every BAS — reviewed by a qualified accountant before anything is finalised.",
  },
  {
    icon: "🎯",
    title: "You stay in control",
    description:
      "Access to dashboards, human accountants, and a dedicated account manager you can actually talk to.",
  },
];

export const SecondarySection = () => {
  return (
    <section className="py-[100px] px-6 lg:px-10 bg-base-white">
      <div className="max-w-[860px] mx-auto text-center fade-in">
        {/* Eyebrow badge */}
        <div className="inline-flex items-center gap-2.5 bg-blue-primary-500/[0.08] px-5 py-2 rounded-full text-[13px] font-semibold text-blue-primary-500 mb-7">
          <span className="text-[14px]">🤖</span> +{" "}
          <span className="text-[14px]">👤</span>
          <span className="ml-1">Our approach</span>
        </div>

        {/* Heading */}
        <h2 className="font-inter text-[36px] leading-[46px] font-extrabold tracking-[-1.5px] mb-6">
          The <span className="text-blue-primary-500">speed of AI.</span>
          <br />
          The <span className="text-textNoConnection">judgement of humans.</span>
        </h2>

        {/* Description */}
        <p className="font-inter text-[18px] leading-[1.8] text-gray-cool-500 max-w-[680px] mx-auto mb-12">
          Most tools still depend on manual effort to produce financial
          statements. Ledgerowl provides a hybrid model with tech and people.
          AI completes the heavy lifting in seconds, automating up to 90% of
          the workflow, while experienced CAs and CPAs verify the results —
          ensuring deadlines are met.
        </p>

        {/* 3 Pillar Cards */}
        <div className="flex flex-col sm:flex-row gap-5 justify-center">
          {pillars.map((pillar) => (
            <div
              key={pillar.title}
              className="bg-cream rounded-2xl p-8 px-7 flex-1 min-w-[220px] max-w-[280px] mx-auto sm:mx-0 border border-black/5 text-left transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)]"
            >
              <span className="text-[28px] block mb-3.5">{pillar.icon}</span>
              <h4 className="font-inter text-[17px] font-bold mb-2">
                {pillar.title}
              </h4>
              <p className="font-inter text-[14px] leading-[1.7] text-gray-cool-500">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
